export const environmentData = {
  run: "development",
  development: {
    clientId: "30653d92-33f3-4410-b2d7-6fe56a1bfec8",
    authority:
      "https://login.microsoftonline.com/30f52344-4663-4c2e-bab3-61bf24ebbed8",
    tenantId: "30f52344-4663-4c2e-bab3-61bf24ebbed8",
    "api-scope":
      "openid 30653d92-33f3-4410-b2d7-6fe56a1bfec8/User.Impersonation",

    apiBaseURL: "https://hm-gilldashboard-api.azurewebsites.net/api",
  },
  staging: {
    clientId: "30653d92-33f3-4410-b2d7-6fe56a1bfec8",
    authority:
      "https://login.microsoftonline.com/30f52344-4663-4c2e-bab3-61bf24ebbed8",
    tenantId: "30f52344-4663-4c2e-bab3-61bf24ebbed8",
    "api-scope":
      "openid 30653d92-33f3-4410-b2d7-6fe56a1bfec8/User.Impersonation",

    apiBaseURL: "https://hm-gilldashboard-api.azurewebsites.net/api",
  },
  production: {
    clientId: "30653d92-33f3-4410-b2d7-6fe56a1bfec8",
    authority:
      "https://login.microsoftonline.com/30f52344-4663-4c2e-bab3-61bf24ebbed8",
    tenantId: "30f52344-4663-4c2e-bab3-61bf24ebbed8",
    "api-scope":
      "openid 30653d92-33f3-4410-b2d7-6fe56a1bfec8/User.Impersonation",
    apiBaseURL: "https://hm-gilldashboard-api.azurewebsites.net/api",
  },
};
